"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionScheduleOperation = exports.RetentionScheduleType = exports.LogicOperator = exports.ComparisonOperator = exports.AssessmentsDisplayLogicAction = exports.AssessmentQuestionSubType = exports.AssessmentQuestionType = exports.AssessmentFormTemplateSource = exports.AssessmentFormTemplateStatus = exports.AssessmentFormStatus = void 0;
/** AssessmentForm status types */
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * AssessmentForm status types
 */
var AssessmentFormStatus;
(function (AssessmentFormStatus) {
    /** The form has been created but has not been shared with assignees */
    AssessmentFormStatus["Draft"] = "DRAFT";
    /** The form has been created from a template and shared to be filled out */
    AssessmentFormStatus["Shared"] = "SHARED";
    /** The form is in process of being answered */
    AssessmentFormStatus["InProgress"] = "IN_PROGRESS";
    /** The form has been fully answered and is being reviewed */
    AssessmentFormStatus["InReview"] = "IN_REVIEW";
    /** The reviewers requested changes to the answers */
    AssessmentFormStatus["ChangesRequested"] = "CHANGES_REQUESTED";
    /** The reviewers rejected the answers */
    AssessmentFormStatus["Rejected"] = "REJECTED";
    /** The reviewers approved the answers */
    AssessmentFormStatus["Approved"] = "APPROVED";
})(AssessmentFormStatus || (exports.AssessmentFormStatus = AssessmentFormStatus = {}));
/** AssessmentFormTemplate status types */
var AssessmentFormTemplateStatus;
(function (AssessmentFormTemplateStatus) {
    /** The template is being created */
    AssessmentFormTemplateStatus["Draft"] = "DRAFT";
    /** The template is ready to be used to create forms */
    AssessmentFormTemplateStatus["Published"] = "PUBLISHED";
})(AssessmentFormTemplateStatus || (exports.AssessmentFormTemplateStatus = AssessmentFormTemplateStatus = {}));
/** How an assessment form template was created */
exports.AssessmentFormTemplateSource = (0, type_utils_1.makeEnum)({
    /** The template was created manually by a user creating sections, questions, etc in the AD or via API  */
    Manual: 'MANUAL',
    /** The template was auto-generated as a side effect of kicking off assessments from the Data Inventory */
    DataInventory: 'DATA_INVENTORY',
    /** The template was auto-generated as a side effect of importing OneTrust assessments */
    Import: 'IMPORT',
});
/** The types of the assessment question */
exports.AssessmentQuestionType = (0, type_utils_1.makeEnum)({
    /** A long-answer text question */
    LongAnswer: 'LONG_ANSWER_TEXT',
    /** A short-answer text question */
    ShortAnswer: 'SHORT_ANSWER_TEXT',
    /** A single-select question */
    SingleSelect: 'SINGLE_SELECT',
    /** A multi-select question */
    MultiSelect: 'MULTI_SELECT',
    /** A file question */
    File: 'FILE',
    /** A static text field that has no answer field */
    Description: 'DESCRIPTION',
});
/**
 * The sub-types of the assessment question
 * TODO: https://transcend.height.app/T-36999 - migrate keys to equal values, just like
 *       StaticAssessmentQuestionSubType and DynamicAssessmentQuestionSubType
 */
exports.AssessmentQuestionSubType = (0, type_utils_1.makeEnum)({
    /** A None subType for types that do not accept subTypes */
    None: 'NONE',
    /** A Custom subType for user-defined select types */
    Custom: 'CUSTOM',
    /** A user */
    User: 'USER',
    /** A team */
    Team: 'TEAM',
    /** A Data SubCategory */
    DataSubCategory: 'DATA_SUB_CATEGORY',
    /** A Processing Purpose SubCategory */
    ProcessingPurposeSubCategory: 'PROCESSING_PURPOSE_SUB_CATEGORY',
    /** A Processing Activity */
    ProcessingActivity: 'PROCESSING_ACTIVITY',
    /** A vendor */
    Vendor: 'VENDOR',
    /** A Region question */
    Region: 'REGION',
    /** A Business Entity */
    BusinessEntity: 'BUSINESS_ENTITY',
    /** The category of the recipient */
    SaaSCategory: 'SAA_S_CATEGORY',
    /** The Data Processing Agreement Status */
    DataProcessingAgreementStatus: 'DATA_PROCESSING_AGREEMENT_STATUS',
    /** The Data Protection Impact Assessment Status */
    DataProtectionImpactAssessmentStatus: 'DATA_PROTECTION_IMPACT_ASSESSMENT_STATUS',
    /** The deprecation state */
    DeprecationState: 'DEPRECATION_STATE',
    /** The identifier */
    Identifier: 'IDENTIFIER',
    /** A Data Silo */
    DataSilo: 'DATA_SILO',
    /** Whether the data silo is recommended for consent manager purposes */
    RecommendedForConsent: 'RECOMMENDED_FOR_CONSENT',
    /** Whether the data silo is recommended for privacy request purposes */
    RecommendedForPrivacy: 'RECOMMENDED_FOR_PRIVACY',
    /** The subject */
    Subject: 'SUBJECT',
    /** The type of retention schedule */
    RetentionType: 'RETENTION_TYPE',
    /** The controllership */
    Controllership: 'CONTROLLERSHIP',
    /** Whether the data silo has personal data */
    HasPersonalData: 'HAS_PERSONAL_DATA',
    /** The Attribute Key referring to a custom field */
    AttributeKey: 'ATTRIBUTE_KEY',
});
/** The possible actions within an assessment question's display logic */
exports.AssessmentsDisplayLogicAction = (0, type_utils_1.makeEnum)({
    /** Display the question */
    Show: 'SHOW',
    /** Skip the question */
    Skip: 'SKIP',
});
/** The comparison operators to use in an assessment question's display logic  */
exports.ComparisonOperator = (0, type_utils_1.makeEnum)({
    /** is equal to */
    IsEqualTo: 'IS_EQUAL_TO',
    /** is not equal to */
    IsNotEqualTo: 'IS_NOT_EQUAL_TO',
    /** is one of */
    IsOneOf: 'IS_ONE_OF',
    /** is not one of */
    IsNotOneOf: 'IS_NOT_ONE_OF',
    /** contains */
    Contains: 'CONTAINS',
    /** is shown */
    IsShown: 'IS_SHOWN',
    /** is not shown */
    IsNotShown: 'IS_NOT_SHOWN',
});
/** The logic operators to use in an assessment question's display logic  */
exports.LogicOperator = (0, type_utils_1.makeEnum)({
    /** and */
    And: 'AND',
    /** or */
    Or: 'OR',
});
/**
 * types of data to be managed by the data retention policy
 */
var RetentionScheduleType;
(function (RetentionScheduleType) {
    RetentionScheduleType["REQUESTS_CREATED_AT"] = "REQUESTS_CREATED_AT";
    RetentionScheduleType["ASSESSMENT_FORM_COMPLETED_AT"] = "ASSESSMENT_FORM_COMPLETED_AT";
})(RetentionScheduleType || (exports.RetentionScheduleType = RetentionScheduleType = {}));
/**
 * operation types for the data retention policy
 * FULL_DELETE: delete full record
 * PARTIAL_DELETE: delete identifiers only
 * NONE: don't do anything to the data
 */
var RetentionScheduleOperation;
(function (RetentionScheduleOperation) {
    RetentionScheduleOperation["FULL_DELETE"] = "FULL_DELETE";
    RetentionScheduleOperation["PARTIAL_DELETE"] = "PARTIAL_DELETE";
    RetentionScheduleOperation["NONE"] = "NONE";
})(RetentionScheduleOperation || (exports.RetentionScheduleOperation = RetentionScheduleOperation = {}));
//# sourceMappingURL=assessmentForm.js.map